var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookOpen = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.667v9.333"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 12a0.667 0.667 0 0 1-0.667-0.667V2.667a0.667 0.667 0 0 1 0.667-0.667h3.333a2.667 2.667 0 0 1 2.667 2.667 2.667 2.667 0 0 1 2.667-2.667h3.333a0.667 0.667 0 0 1 0.667 0.667v8.667a0.667 0.667 0 0 1-0.667 0.667h-4a2 2 0 0 0-2 2 2 2 0 0 0-2-2z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookOpen);
export default ForwardRef;